export default __webpack_public_path__ + "static/media/flag-ja.817dde66.svg";